export default __webpack_public_path__ + "static/wamo-firm-andshake-6ccf0f6967388977ddfae3bd9b21109f.jpg";